import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import {Button} from "./buttons";

const IdleTimeoutModal = ({ showModal, handleExtendSession, handleLogout, isExtendingSession, logoutAfterMS }) => {
    React.useEffect(() => {
        if (!showModal) {
            return undefined;
        }

        const logoutTimer = setTimeout(() => handleLogout(true), logoutAfterMS);
        return () => clearTimeout(logoutTimer);
    }, [showModal, handleLogout, logoutAfterMS]);

    return (
        <Modal show={showModal} backdrop="static">
            <Modal.Header>
                <Modal.Title>{`Your Session Will End In ${logoutAfterMS / 60 / 1000} Minutes.`}</Modal.Title>
            </Modal.Header>
            <Modal.Body>Do You Want To Extend Your Session?</Modal.Body>
            <Modal.Footer>
                <Button onClick={() => handleLogout(false)}>
                    Logout
            </Button>
                <Button onClick={handleExtendSession} disabled={isExtendingSession}>
                    {isExtendingSession ? "Extending..." : "Extend Session"}
            </Button>
            </Modal.Footer>
        </Modal>
    )
}

IdleTimeoutModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    handleExtendSession: PropTypes.func.isRequired,
    handleLogout: PropTypes.func.isRequired,
    isExtendingSession: PropTypes.bool,
    logoutAfterMS: PropTypes.number.isRequired,
};

IdleTimeoutModal.defaultProps = {
    isExtendingSession: false,
};

export default IdleTimeoutModal
